import { EnumerationsLogic, Translations } from "../../logic";
import { NonProfitOrgUsecase, UserDefinedRow } from "../../model";
import { BaseUsecaseLogic } from "../BaseUsecaseLogic";
import { UsecaseValidationMessage } from "../UsecaseValidationMessage";

/**
 * Handles the usecase for Non-profit organization specific allowances.
 */
export class NonProfitOrgUsecaseLogic extends BaseUsecaseLogic {
  /** Gets validation message for BoardUsecaseLogic  */
  public getUcValidation(row: UserDefinedRow): UsecaseValidationMessage {
    const data: NonProfitOrgUsecase = row.data || {};
    if (!data.kind) {
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.nonProfitOrg.noKind",
      };
    }
    return { type: "default", msg: `${Translations.get("SALAXY.VALIDATION.Usecases.nonProfitOrg.default")} ${EnumerationsLogic.getEnumLabel("NonProfitOrgKind", data.kind)}` };
  }
}
